import { create } from "zustand"

const STORAGE_KEY = "lang"
const USER_SELECTED_KEY = "lang_user_selected"
const SUPPORTED_LANGS = new Set(["ko", "en", "es"])

const normalizeLang = (value) => {
  if (SUPPORTED_LANGS.has(value)) return value
  return null
}

const detectBrowserLang = () => {
  const langs = [...(navigator.languages || []), navigator.language, navigator.userLanguage].filter(
    Boolean
  )

  const first = String(langs[0] || "").toLowerCase()
  const base = first.split("-")[0]

  if (base === "ko") return "ko"
  if (base === "es") return "es"
  return "en"
}

const safeGet = (key) => {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

const safeSet = (key, value) => {
  try {
    localStorage.setItem(key, value)
  } catch {
    return null
  }
}

const getInitialLangState = () => {
  const savedLang = normalizeLang(safeGet(STORAGE_KEY))
  const userSelected = safeGet(USER_SELECTED_KEY) === "true"

  if (userSelected && savedLang) {
    return { lang: savedLang, userSelected: true }
  }

  return { lang: detectBrowserLang(), userSelected: false }
}

export const langStore = create((set, get) => {
  const initial = getInitialLangState()

  return {
    lang: initial.lang,
    userSelected: initial.userSelected,

    setLang: (lang) => {
      const next = normalizeLang(lang) || "en"
      safeSet(STORAGE_KEY, next)
      safeSet(USER_SELECTED_KEY, "true")
      set({ lang: next, userSelected: true })
    },

    resetToBrowserLang: () => {
      const next = detectBrowserLang()
      safeSet(STORAGE_KEY, next)
      safeSet(USER_SELECTED_KEY, "false")
      set({ lang: next, userSelected: false })
    },

    syncIfNotUserSelected: () => {
      const { userSelected, lang } = get()
      if (userSelected) return

      const next = detectBrowserLang()
      if (next === lang) return

      safeSet(STORAGE_KEY, next)
      set({ lang: next })
    }
  }
})
